var exports = {
  "xn": "EmbedYouTube.module__thumbnail___bFYtNX",
  "SK": "EmbedYouTube.module__thumbnailPlaceholder___bFYtNX",
  "Lw": "EmbedYouTube.module__overlay___bFYtNX",
  "lW": "EmbedYouTube.module__posterImage___bFYtNX",
  "_y": "EmbedYouTube.module__thumbnailClickTarget___bFYtNX",
  "gO": "EmbedYouTube.module__controlsContainer___bFYtNX",
  "GC": "EmbedYouTube.module__buttonGroup___bFYtNX",
  "kL": "EmbedYouTube.module__container___bFYtNX",
  "j": "EmbedYouTube.module__videoContainer___bFYtNX",
  "pU": "EmbedYouTube.module__iframe___bFYtNX",
};

module.exports = exports;
